import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import filterHelpers from "app/utils/filterHelpers";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import FilterBar from "app/components/FilterBar";
import { styleSheet, colors, sizes, DARK, HEIGHT } from "app/utils/styleSheet";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

// import {Sigma, RandomizeNodePositions, RelativeSize, EdgeShapes, NodeShapes, NOverlap, } from 'react-sigma';
import Graph from "react-graph-vis";
import "vis-network/dist/dist/vis-network.css";

import { add } from "app/actions/values";
import store from "app/redux/store";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

const WEB = Platform.OS == "web";
const REVERSE = false;
const CONSTELATE = true;

let fixDuplicateError = false;
// fixDuplicateError = true;

import { StyleContext } from "app/contexts/Style";

export default class Map extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      topLevel: null,
      levelIds: {},
      loading: true,
      mounting: true,
      query: "",
      hideComplete: true,
      hierarchical: false,
      // hierarchical: true,
      stabalize: false,
      showDuplicates: false,
      sequentialMode: true,
      mapView: false,
      selectedValueId: null,
      redrawKey: 0,
      scrollHeight: null,
      expandedIds: [],
      expandedFamilyIds: [],
      graphData: { nodes: [], edges: [] },
    };
  }

  async componentDidMount() {
    let values = await storageActions.fetchItem("allValues");
    if (!values?.length || fixDuplicateError) {
      this.fetch();
    } else {
      console.log("local values", values);
      store.dispatch(add(values));
      await this.setState({ values, allValues: values });
      this.updateValues();
      this.setState({ loading: false, fetching: false });
    }
  }

  fetch = async () => {
    // let topValues = await valueActions.index("root");
    if (this.state.fetching) return;
    this.setState({ fetching: true });
    let values = await valueActions.index([], { include_levels: true });
    if (!values?.length) {
      alert("something whent wrong");
      return;
    }
    storageActions.saveItem("allValues", values);
    console.log("saving in local storage", values);
    await this.setState({ values, allValues: values });
    this.updateValues();
    this.setState({ loading: false, fetching: false });
  };

  updateValues = async () => {
    let { allValues, sequentialMode, expandedIds, expandedFamilyIds } =
      this.state;
    let values = [];
    if (sequentialMode && !expandedFamilyIds?.length) {
      values = allValues.filter(
        (v) =>
          !v.parent_ids?.length ||
          expandedIds.includes(v.id) ||
          !!textHelpers.intersection(v.parent_ids, expandedIds).length,
      );
      console.log("sequential values:", values);
    } else values = allValues;
    // values = values.filter((v) => v.title != "individuate style");
    //   (v) => v.id != 680 && v.title != "philosophy" && v.id != 891
    // );
    values = filterHelpers.apply(values);
    let levelIds = valueHelpers.getLevelIds(values);
    // values = valueHelpers.filterToCurrentRevisions(values);
    let topLevel = valueHelpers.getTopLevel(levelIds);
    console.log(values, levelIds, topLevel);
    await this.setState({
      values,
      levelIds,
      topLevel,
    });
    this.updateGraphData();
    // let graphData = this.generateGraphData();
    // this.setState({ graphData });
  };

  render() {
    let {
      values,
      loading,
      query,
      rendering,
      hierarchical,
      familyIds,
      redrawKey,
      scrollHeight,
      showDuplicates,
      mapView,
      stabalize,
      fetching,
      sequentialMode,
    } = this.state;

    let buttonColorOptions = [
      colors.trim,
      colors.active,
      colors.activeHighlight,
    ];

    return (
      <View style={this.styles().container} key={redrawKey}>
        <StatusBar style="auto" />

        <FilterBar temporary onChangeFilters={this.updateValues} />

        <View style={[this.styles().row, this.styles().queryRow]}>
          <TouchableOpacity
            onPress={this.fetch}
            style={this.styles().icon}
            disabled={fetching}
          >
            {fetching || loading ? (
              <ActivityIndicator />
            ) : (
              <Ionicons
                name="md-refresh"
                size={this.context.sizes.itemHeight}
                color={this.context.colors.foreground}
              />
            )}
          </TouchableOpacity>
          <TouchableOpacity
            onPress={async () => {
              await this.setState({ showDuplicates: !showDuplicates });
              // store.dispatch({type: 'update'})
              this.updateGraphData();
              // let graphData = this.generateGraphData();
              // this.setState({ graphData });
            }}
            style={this.styles().icon}
          >
            <Text
              style={{
                color: showDuplicates
                  ? this.context.colors.active
                  : this.context.colors.trim,
              }}
            >
              Dups
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ mapView: !mapView })}
            style={this.styles().icon}
          >
            <Text
              style={{
                color: mapView
                  ? this.context.colors.active
                  : this.context.colors.trim,
              }}
            >
              Map
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ hierarchical: !hierarchical })}
            style={{ marginLeft: this.context.sizes.base }}
          >
            <Entypo
              name="flow-tree"
              size={this.context.sizes.itemHeight}
              color={
                hierarchical
                  ? this.context.colors.active
                  : this.context.colors.trim
              }
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ stabalize: !stabalize })}
            style={{ marginLeft: this.context.sizes.base }}
          >
            <FontAwesome
              name="anchor"
              size={this.context.sizes.itemHeight}
              color={
                stabalize
                  ? this.context.colors.active
                  : this.context.colors.trim
              }
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ redrawKey: redrawKey + 1 })}
            style={this.styles().icon}
          >
            <MaterialCommunityIcons
              name="draw"
              size={this.context.sizes.itemHeight}
              color={this.context.colors.trim}
            />
            <Text style={{ color: this.context.colors.trim }}>RE</Text>
          </TouchableOpacity>
          <Text
            onPress={async () => {
              await this.setState({ sequentialMode: !sequentialMode });
              this.updateValues();
            }}
            button
            selectedButton={!sequentialMode}
          >
            Expand All
          </Text>
        </View>

        {rendering && <ActivityIndicator />}

        {this.renderVisNetwork()}

        <View />
      </View>
    );
  }

  updateGraphData = async () => {
    this.setState({ loading: true });
    let graphData = await this.generateGraphData();
    this.setState({ graphData, loading: false });
  };

  generateGraphData = async () => {
    return new Promise(async (resolve) => {
      console.warn("------------generating graph data");
      let {
        values,
        topLevel,
        mapView,
        hierarchical,
        stabalize,
        network,
        graphData,
        expandedFamilyIds,
      } = this.state;
      console.log("graphdata values:", values);
      let rootNode = {
        id: "root",
        label: " ",
        value: topLevel + 5,
        x: 0,
        y: 0,
        fixed: { x: true, y: true },
        valueColor: this.context.colors.trim,
        mass: 3,
        color: {
          background: this.context.colors.empty,
          border: this.context.colors.trim,
          hover: {
            background: this.context.colors.empty,
            border: this.context.colors.trim,
          },
          highlight: {
            background: this.context.colors.empty,
            border: this.context.colors.trim,
          },
        },
      };
      let nodes = [rootNode];
      let edges = [];

      let startingLevel = mapView
        ? values.filter((v) => !v.child_ids.length)
        : values.filter((v) => !v.parent_ids.length);

      const promises = startingLevel.map(async (value, i) => {
        await new Promise((r) => setTimeout(r, 0));
        console.log("get family for", value.title);
        let family = await this.generateFamily(
          value,
          values,
          rootNode,
          !!expandedFamilyIds?.length,
        );
        console.log(`awaited family ${value.title}`, family);

        nodes = [...nodes, ...family.nodes];
        edges = [...edges, ...family.edges];
      });
      await Promise.all(promises);

      console.log("nodes:", nodes);
      // nodes = [{id: 0}] // fix cache

      if (this.state.hierarchical) {
        setTimeout(() => {
          console.log("remove hierarchy");
          this.setState({ hierarchical: false });
        }, 5000);
      }

      console.warn("------------graph data complete");
      resolve({ nodes, edges });
    });

    // return { nodes, edges };
  };

  generateFamily = async (
    value,
    values,
    parentNode = null,
    checkForExpandedFamilies = false,
  ) => {
    return new Promise(async (resolve) => {
      let {
        showDuplicates,
        topLevel,
        mapView,
        expandedFamilyIds,
        expandedIds,
      } = this.state;
      let nodes = [];
      let edges = [];

      let node = this.generateNode(value, parentNode);
      nodes.push(node);
      if (!!parentNode) {
        let length = 35;
        length = 35 + valueHelpers.getLevel(value) * 50;
        if (
          !mapView &&
          valueHelpers.getLevel(value) != topLevel - 1 &&
          parentNode.id == "root"
        ) {
          length = 500 + (topLevel - valueHelpers.getLevel(value)) * 50;
        } else if (parentNode.id == "root") {
          // length = 70
          // console.log('spring length for ', value.text, length, valueHelpers.getLevel(value), topLevel-1)
        }

        edges.push({
          to: node.rootId,
          from: node.id,
          color: parentNode.valueColor,
          // length,
        });
      }

      let includeAllDescentants = false;
      if (checkForExpandedFamilies && expandedFamilyIds.includes(value.id)) {
        includeAllDescentants = true;
      }

      let nextGen = [];
      if (
        checkForExpandedFamilies &&
        !expandedFamilyIds.includes(value.id) &&
        !expandedIds.includes(value.id)
      ) {
        nextGen = [];
      } else {
        nextGen = mapView
          ? valueHelpers.getParents({ value, values })
          : valueHelpers.getChildren({
              value,
              sort: false,
              includePreviousRevisions: true,
              includeNotes: true,
              values,
            });
      }

      // nextGen = valueHelpers.applyBottomLevelParentId(nextGen)
      const promises = nextGen.map(async (child) => {
        if (!showDuplicates && !includeAllDescentants) {
          // let bottomParentLevel = child.bottomParentLevel
          // let bottomParentId = child.bottomParentId
          let { bottomParentLevel, bottomParentId } =
            valueHelpers.getBottomLevelParent(child);
          let valueLevel = valueHelpers.getLevel(value);
          if (bottomParentLevel <= valueLevel) {
            if (!!bottomParentId && bottomParentId != value.id) {
              return;
            }
          }
        }

        await new Promise((r) => setTimeout(r, 0));
        let family = await this.generateFamilyRecursively(child, values, node);
        nodes = [...nodes, ...family.nodes];
        edges = [...edges, ...family.edges];
      });
      await Promise.all(promises);

      resolve({ nodes, edges });
    });
    // return { nodes, edges };
  };

  generateFamilyRecursively = async (value, values, parentNode = null) => {
    return new Promise(async (resolve) => {
      await new Promise((r) => setTimeout(r, 0));
      let res = await this.generateFamily(value, values, parentNode);
      resolve(res);
    });
  };

  generateNode = (value, parentNode = null) => {
    let { expandedFamilyIds } = this.state;
    let icon =
      valueHelpers.getIcon(value) || (value.is_note ? "text" : "placeholder");
    let color = valueHelpers.getColor(value);
    let familyColor = valueHelpers.getColor(value, "familyColors") || color;

    let darkColor = colorHelpers.modifyHex(color, 0.6);
    let background = darkColor;
    let border = familyColor;

    let valueColor = color;

    if (expandedFamilyIds.includes(value.id)) {
      background = color;
      border = color;
      valueColor = color;
      color = this.context.colors.empty;
    }

    let id = value.id;
    let rootId = value.id;
    if (!!parentNode && !!parentNode.id) {
      id = `${parentNode.id}_${value.id}`;
      rootId = parentNode.id;
    }
    let x,
      y,
      fixed = undefined;

    // x =
    // y =

    let valueText = valueHelpers.filterRichText(
      value.title || value.text,
      value,
    );
    return {
      id,
      valueId: value.id,
      rootId,
      title: valueText,
      label: iconHelpers.unicode(icon),
      font: {
        color,
        face: iconHelpers.fontFamily(icon),
        size: 33,
      },
      color: {
        background,
        border,
        hover: {
          background,
          border,
        },
        highlight: expandedFamilyIds.includes(value.id)
          ? {
              border: darkColor,
              background: darkColor,
            }
          : {
              border,
              background: this.context.colors.empty,
            },
      },
      valueColor,
      value: valueHelpers.getLevel(value) + 1,
      x,
      y,
      fixed,
    };
  };

  renderVisNetwork = () => {
    let { hierarchical, stabalize, sequentialMode, network, graphData } =
      this.state;

    const options = {
      layout: {
        hierarchical: {
          enabled: hierarchical,
          levelSeparation: 200, // default 150
          nodeSpacing: 20, //  Number  100 Minimum distance between nodes on the free axis. This is only for the initial layout. If you enable physics, the node distance there will be the effective node distance.
          // treeSpacing: 500, //  Number  200 Distance between different trees (independent networks). This is only for the initial layout. If you enable physics, the repulsion model will denote the distance between the trees.
          blockShifting: true, //  Boolean true  Method for reducing whitespace. Can be used alone or together with edge minimization. Each node will check for whitespace and will shift it's branch along with it for as far as it can, respecting the nodeSpacing on any level. This is mainly for the initial layout. If you enable physics, the layout will be determined by the physics. This will greatly speed up the stabilization time though!
          // hierarchical.edgeMinimization Boolean true  Method for reducing whitespace. Can be used alone or together with block shifting. Enabling block shifting will usually speed up the layout process. Each node will try to move along its free axis to reduce the total length of it's edges. This is mainly for the initial layout. If you enable physics, the layout will be determined by the physics. This will greatly speed up the stabilization time though!
          parentCentralization: false, //  When true, the parents nodes will be centered again after the layout algorithm has been finished.
          direction: "DU", //  String  'UD'  The direction of the hierarchical layout. The available options are: UD, DU, LR, RL. To simplify: up-down, down-up, left-right, right-left.
          // sortMethod: "directed", // String  'hubsize' The algorithm used to ascertain the levels of the nodes based on the data. The possible options are: hubsize, directed.
          // Hubsize takes the nodes with the most edges and puts them at the top. From that the rest of the hierarchy is evaluated.
          // Directed adheres to the to and from data of the edges. A --> B so B is a level lower than A.
          // shakeTowards: 'roots', // String  'roots' Controls whether in directed layout should all the roots be lined up at the top and their child nodes as close to their roots as possible (roots) or all the leaves lined up at the bottom and their parents as close to their children as possible (leaves, default).
        },
      },
      // improvedLayout: true,
      physics: {
        enabled: true,
        // enabled: false,
        // wind: { x: 1, y: 0, },
        minVelocity: stabalize ? 3 : 0,
        stabilization: {
          enabled: true,
          iterations: 5000,
          fit: true,
        },
        barnesHut: {
          // theta: 0.9, // 0.5 This parameter determines the boundary between consolidated long range forces and individual short range forces. To oversimplify higher values are faster but generate more errors, lower values are slower but with less errors.
          gravitationalConstant: -600000, // -2000 - lower == greater repulsion
          // gravitationalConstant: sequentialMode ? -5000 : -20000, // -2000 - lower == greater repulsion
          centralGravity: 0.01, // 0.3 central pull
          // springLength: sequentialMode ? 300 : 70, // 95 - length
          // springLength: 60, // 95 - length
          springConstant: 0.06, // 0.04 - sturdiness
          damping: stabalize ? 1 : 0.4, // 0.09 (0-1) - smoothing
          avoidOverlap: 0.8, // (0-1)
        },
      },
      edges: {
        color: "#000000",
        width: 2,
        hoverWidth: 3,
        dashes: true,
        smooth: {
          enabled: false,
          type: "continuous",
          // type: 'dynamic',
        },
        arrows: {
          to: {
            enabled: false,
          },
          //   middle: {
          //     enabled: true,
          //     // imageHeight: 32,
          //     // imageWidth: 32,
          //     scaleFactor: 1,
          //     // src: "https://visjs.org/images/visjs_logo.png",
          //     // type: "image"
          //     type: 'arrow',
          //   },
          //   from: {
          //     enabled: false,
          //   },
        },
      },
      nodes: {
        shape: "circle",
        value: 1,
        scaling: {
          min: 10,
          max: 20,
          label: {
            enabled: true,
            min: 5,
            max: 10,
            max: 9,
            maxVisible: 20,
            drawThreshold: 5,
          },
          customScalingFunction: function (min, max, total, value) {
            // return value * 4;
            return value * 5;
          },
        },
        borderWidth: 4,
        // borderWidthSelected: 10,
      },
      interaction: {
        hover: true,
        keyboard: {
          enabled: true,
        },
      },
      height: `${HEIGHT}px`,
    };

    const events = {
      select: (event) => {
        console.log(event, event?.event?.srcEvent?.metaKey);
        let { nodes, edges } = event;
        if (!!nodes[0]) {
          let ids = nodes[0].split("_");
          let id = ids[ids.length - 1];
          if (event?.event?.srcEvent?.metaKey) {
            this.toggleFamilyExpansion(id);
          } else {
            this.selectById(id);
          }

          // this.state.network.fit();
          // this.state.network.focus(node.id);
          // this.state.network.releaseNode();
          // this.state.network.moveTo({
          //   position: {x:Number, y:Number},
          //   scale: Number,
          //   offset: {x:Number, y:Number}
          //   animation: { // -------------------> can be a boolean too!
          //     duration: Number
          //     easingFunction: String
          //   }
          // });

          let nodeIds = graphData.nodes
            .filter((n) => n.id?.endsWith(`_${id}`))
            .map((n) => n.id);
          network.selectNodes(nodeIds);
        } else {
          this.setState({ selectedValueId: null });
        }
      },
    };
    return (
      <Graph
        graph={graphData}
        options={options}
        events={events}
        ref={(ref) => {
          this[`visRef`] = ref;
        }}
        vis={(vis) => {
          console.log(vis);
          return (this.vis = vis);
        }}
        getNetwork={(network) => {
          //  if you want access to vis.js network api you can set the state in a parent component using this property
          this.setState({ network });
        }}
      />
    );
  };

  selectById = async (id) => {
    let { values, selectedValueId, sequentialMode, expandedIds } = this.state;
    let value = values.find((v) => v.id == id);
    console.log(id, value);
    if (false && id == selectedValueId) {
      if (!!value) {
        RootNavigation.navigate("Value", { value, id: value.id });
      }
    } else {
      this.setState({ selectedValueId: id });
      id = parseInt(id);
      if (sequentialMode) {
        if (expandedIds.includes(id)) {
          expandedIds.splice(expandedIds.indexOf(id), 1);
        } else {
          expandedIds.push(id);
        }
        await this.setState({ expandedIds });
        console.log("expandedIds", expandedIds);
        this.updateValues();
      }
    }
  };

  toggleFamilyExpansion = async (id) => {
    let { values, selectedValueId, sequentialMode, expandedFamilyIds } =
      this.state;
    let value = values.find((v) => v.id == id);
    console.log("family expansion!!", id, value);

    this.setState({ selectedValueId: id });
    id = parseInt(id);
    if (sequentialMode) {
      if (expandedFamilyIds.includes(id)) {
        expandedFamilyIds.splice(expandedFamilyIds.indexOf(id), 1);
      } else {
        expandedFamilyIds.push(id);
      }
      await this.setState({ expandedFamilyIds });
      console.log("expandedFamilyIds", expandedFamilyIds);
      this.updateValues();
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-around",
      // backgroundColor: DARK ? undefined : this.context.colors.foreground,
    },
    row: {
      flexGrow: 1,
      borderColor: colors.trim,
      // borderBottomWidth: 1,
      alignSelf: "stretch",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: this.context.sizes.large,
    },
    queryRow: {
      flexGrow: 0,
      height: 50,
      padding: this.context.sizes.base,
      justifyContent: "flex-start",
    },
    input: {
      ...styleSheet.input,
      alignSelf: "stretch",
      flex: 1,
    },
    icon: {
      marginLeft: this.context.sizes.base,
      minWidth: this.context.sizes.base,
      minHeight: this.context.sizes.base,
      // borderWidth: 1, borderColor: 'white',
    },
  });
}
